import { useCallback } from 'react';
import styled from 'styled-components';
import { useFeedbackDialogContext } from '@frameio/shared/contexts/ModalContext/ModalContext';
import { MenuButton } from '@frameio/vapor';
import { IconLightbulb } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/PremiereIntegrationNavItems';

TEXT.DEFINE({
  /** Menu item label shown in the Premiere extension that opens a feedback/report flow for the new extension */
  submitFeedback: 'Submit Feedback',
});

const StyledMenuButton = styled(MenuButton)`
  white-space: pre-wrap;
`;

export function PremiereIntegrationNavItem() {
  const { openFeedbackDialog } = useFeedbackDialogContext();
  const onClick = useCallback(() => {
    openFeedbackDialog('integrationsFeedback');
  }, [openFeedbackDialog]);

  return (
    <StyledMenuButton
      data-dd-action-name="primary-nav.premiere-integration"
      iconBefore={<IconLightbulb />}
      isLink={false}
      onClick={onClick}
    >
      {TEXT.submitFeedback}
    </StyledMenuButton>
  );
}
